/**
 * アクションタイプ
 */
export var ActionType;

(function (ActionType) {
  /**
   * 未選択
   */
  ActionType[ActionType["None"] = -1] = "None";
  /**
  * 可視性
  */

  ActionType[ActionType["Visibility"] = 0] = "Visibility";
  /**
  * 再生
  */

  ActionType[ActionType["Play"] = 1] = "Play";
  /**
  * ボイスメモ
  */

  ActionType[ActionType["VoiceMemo"] = 2] = "VoiceMemo";
  /**
  * リセット
  */

  ActionType[ActionType["Reset"] = 3] = "Reset";
  /**
  * スケール
  */

  ActionType[ActionType["Scale"] = 4] = "Scale";
  /**
  * ロック
  */

  ActionType[ActionType["Lock"] = 5] = "Lock";
  /**
  * 重力
  */

  ActionType[ActionType["Gravity"] = 6] = "Gravity";
  /**
   * チャットボット
   */

  ActionType[ActionType["ChatBot"] = 7] = "ChatBot";
  /**
   * イマーシブ
   */

  ActionType[ActionType["Immersive"] = 8] = "Immersive";
  /**
   * 集合
   */

  ActionType[ActionType["Gather"] = 9] = "Gather";
  /**
   * 振動
   */

  ActionType[ActionType["Vibration"] = 10] = "Vibration";
  /**
   * ロールバック
   */

  ActionType[ActionType["Rollback"] = 11] = "Rollback";
  /**
   * 待機
   */

  ActionType[ActionType["Wait"] = 12] = "Wait";
  /**
   * 切り替え
   */

  ActionType[ActionType["SwitchGroup"] = 13] = "SwitchGroup";
})(ActionType || (ActionType = {}));